var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('th',[_vm._v(_vm._s(_vm.insurance.title))]),_vm._v(" "),_vm._l((_vm.insurance.exists),function(cardInsurance,i){return _c('td',{key:i,domProps:{"innerHTML":_vm._s(_vm.checkmarkBoolean(cardInsurance))}})})],2)}
var staticRenderFns = []

export { render, staticRenderFns }